import { lazy } from 'react';
import ApiAuthorzationRoutes from './components/api-authorization/ApiAuthorizationRoutes';

// Lazy-load each page into its own chunk so a visitor only downloads the route they actually hit.
// A landing-page visitor no longer downloads the entire admin app — big win on the recipient's
// click -> page time, especially on mobile. (Named exports are mapped to a default for React.lazy.)
const Home = lazy(() => import('./pages/Home').then(m => ({ default: m.Home })));
const Projects = lazy(() => import('./pages/Projects').then(m => ({ default: m.Projects })));
const Actions = lazy(() => import('./pages/Actions').then(m => ({ default: m.Actions })));
const Logs = lazy(() => import('./pages/Logs').then(m => ({ default: m.Logs })));
const Project = lazy(() => import('./pages/Project').then(m => ({ default: m.Project })));
const NewProject = lazy(() => import('./pages/NewProject').then(m => ({ default: m.NewProject })));
const RowForm = lazy(() => import('./pages/public/RowForm').then(m => ({ default: m.RowForm })));
const LandingPage = lazy(() => import('./pages/public/LandingPage').then(m => ({ default: m.LandingPage })));
const LinkCategories = lazy(() => import('./pages/LinkCategories').then(m => ({ default: m.LinkCategories })));
const FileUpload = lazy(() => import('./pages/public/FileUpload').then(m => ({ default: m.FileUpload })));
const CaptureScreen = lazy(() => import('./pages/CaptureScreen').then(m => ({ default: m.CaptureScreen })));
const HubSpotInstall = lazy(() => import('./pages/public/HubSpotInstall').then(m => ({ default: m.HubSpotInstall })));
const PipedriveInstall = lazy(() => import('./pages/public/PipedriveInstall').then(m => ({ default: m.PipedriveInstall })));
const VideoPlayer = lazy(() => import('./pages/VideoPlayer'));
const MultiUpload = lazy(() => import('./pages/MultiUpload'));
const FilesList = lazy(() => import('./components/FilesList').then(m => ({ default: m.FilesList })));

const AppRoutes = [
    {
        index: true,
        requireAuth: true,
        element: <Home/>,
    },
    {
        path: '/new-project',
        requireAuth: true,
        element: <NewProject/>,
    },
    {
        path: '/pjs',
        requireAuth: true,
        element: <Projects/>
    },
    {
        path: '/actions',
        requireAuth: true,
        element: <Actions />
    },
    {
        path: '/files',
        requireAuth: true,
        element: <FilesList />
    },
    {
        path: '/pjs/:id',
        requireAuth: true,
        element: <Project/>
    },
    {
        path: '/links',
        requireAuth: true,
        element: <LinkCategories/>
    },
    {
        path: '/multi-upload',
        requireAuth: true,
        element: <MultiUpload/>
    },
    {
        path: '/infologs',
        requireAuth: true,
        element: <Logs />
    },
    // Public routes
    {
        path: '/app/hubspot/install',
        requireAuth: false,
        element: <HubSpotInstall />
    },
    {
        path: '/app/pipedrive/install',
        requireAuth: false,
        element: <PipedriveInstall />
    },
    {
        path: '/guest/form/:id',
        requireAuth: false,
        element: <RowForm/>
    },
    {
        path: '/guest/lp/:id',
        requireAuth: false,
        element: <LandingPage/>
    },
    {
        path: '/guest/upload',
        requireAuth: false,
        element: <FileUpload/>
    },
    {
        path: '/i/guest-view',
        requireAuth: false,
        element: <VideoPlayer/>
    },
    {
        path: '/guest-view',
        requireAuth: false,
        element: <VideoPlayer/>
    },
    {
        path: '/app/capture',
        requireAuth: true,
        element: <CaptureScreen />
    },
    ...ApiAuthorzationRoutes
];

export default AppRoutes;
